import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={123}
    height={162}
    viewBox="0 0 123 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={37.5971}
      cy={50.9857}
      r={9.01921}
      transform="rotate(-168.758 37.5971 50.9857)"
      fill="url(#paint0_radial_25_671)"
    />
    <circle
      cx={37.5971}
      cy={50.9857}
      r={9.01921}
      transform="rotate(-168.758 37.5971 50.9857)"
      fill="url(#paint1_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={37.5971}
      cy={50.9857}
      r={9.01921}
      transform="rotate(-168.758 37.5971 50.9857)"
      fill="url(#paint2_radial_25_671)"
    />
    <ellipse
      cx={38.4558}
      cy={56.9463}
      rx={1.00213}
      ry={1.33618}
      transform="rotate(-119.714 38.4558 56.9463)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={36.0025}
      cy={57.9653}
      rx={0.323194}
      ry={0.430925}
      transform="rotate(-91.7296 36.0025 57.9653)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={43.7571}
      cy={52.5508}
      rx={1.33618}
      ry={2.00427}
      transform="rotate(-164.397 43.7571 52.5508)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={43.3773}
      cy={52.0983}
      rx={2.43116}
      ry={3.64673}
      transform="rotate(-161.548 43.3773 52.0983)"
      fill="white"
      fillOpacity={0.06}
    />
    <circle
      cx={36.2646}
      cy={126.5}
      r={35.5}
      fill="url(#paint3_radial_25_671)"
    />
    <circle
      cx={33.2115}
      cy={123.447}
      r={15.5}
      transform="rotate(33.0706 33.2115 123.447)"
      fill="url(#paint4_radial_25_671)"
    />
    <circle
      cx={33.2115}
      cy={123.447}
      r={15.5}
      transform="rotate(33.0706 33.2115 123.447)"
      fill="url(#paint5_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={33.2115}
      cy={123.447}
      r={15.5}
      transform="rotate(33.0706 33.2115 123.447)"
      fill="url(#paint6_radial_25_671)"
      fillOpacity={0.2}
    />
    <path
      d="M48.5239 121.042C47.5725 117.469 45.3471 114.223 42.0051 112.047C34.8315 107.375 25.2294 109.404 20.5582 116.578C18.382 119.92 17.6599 123.789 18.2348 127.441C17.144 123.345 17.7276 118.821 20.2226 114.989C24.8937 107.815 34.4958 105.787 41.6695 110.458C45.5011 112.953 47.8648 116.855 48.5239 121.042Z"
      fill="url(#paint7_linear_25_671)"
    />
    <ellipse
      cx={35.6504}
      cy={113.389}
      rx={1.72222}
      ry={2.2963}
      transform="rotate(82.1142 35.6504 113.389)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={40.2154}
      cy={113.331}
      rx={0.555426}
      ry={0.740568}
      transform="rotate(110.099 40.2154 113.331)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={24.3844}
      cy={117.014}
      rx={2.2963}
      ry={3.44444}
      transform="rotate(37.4313 24.3844 117.014)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={24.701}
      cy={117.978}
      rx={4.17807}
      ry={6.26711}
      transform="rotate(40.2805 24.701 117.978)"
      fill="white"
      fillOpacity={0.06}
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 80.8444 13.2496)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 80.8444 13.2496)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 67.5108 3.94453)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 67.5108 3.94453)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 64.562 21.5839)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 64.562 21.5839)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 51.5721 41.9672)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 51.5721 41.9672)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 70.888 38.4151)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 70.888 38.4151)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 89.0762 43.3722)"
      fill="white"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 89.0762 43.3722)"
      fill="white"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 22.9512 58.8527)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 22.9512 58.8527)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 2.83936 76.8659)"
      fill="#028AB5"
    />
    <circle
      cx={0.931012}
      cy={0.931012}
      r={0.931012}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 2.83936 76.8659)"
      fill="#028AB5"
    />
    <circle
      cx={3.72405}
      cy={3.72405}
      r={3.72405}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 47.3267 23.2725)"
      fill="#3DF3FF"
    />
    <circle
      cx={2.00214}
      cy={2.00214}
      r={2.00214}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 115.983 53)"
      fill="#C8FCFF"
    />
    <circle
      cx={2.79303}
      cy={2.79303}
      r={2.79303}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 11.9047 122.947)"
      fill="#14A59C"
    />
    <circle
      cx={1.86202}
      cy={1.86202}
      r={1.86202}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 22.5204 77.846)"
      fill="#3DF3FF"
    />
    <circle
      cx={1.86202}
      cy={1.86202}
      r={1.86202}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 40.0117 72.3189)"
      fill="#3DF3FF"
    />
    <circle
      cx={1.17335}
      cy={1.17335}
      r={1.17335}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 84.748 51)"
      fill="white"
      fillOpacity={0.4}
    />
    <circle
      cx={1.86202}
      cy={1.86202}
      r={1.86202}
      transform="matrix(-0.744901 0.667175 0.667175 0.744901 6.19629 95.7042)"
      fill="#3DF3FF"
    />
    <circle
      cx={90.6044}
      cy={66.6045}
      r={9.01921}
      transform="rotate(84.1734 90.6044 66.6045)"
      fill="url(#paint8_radial_25_671)"
    />
    <circle
      cx={90.6044}
      cy={66.6045}
      r={9.01921}
      transform="rotate(84.1734 90.6044 66.6045)"
      fill="url(#paint9_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={90.6044}
      cy={66.6045}
      r={9.01921}
      transform="rotate(84.1734 90.6044 66.6045)"
      fill="url(#paint10_radial_25_671)"
    />
    <ellipse
      cx={96.0504}
      cy={64.0341}
      rx={1.00213}
      ry={1.33618}
      transform="rotate(133.217 96.0504 64.0341)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={97.7446}
      cy={66.0802}
      rx={0.323194}
      ry={0.430925}
      transform="rotate(161.201 97.7446 66.0802)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={90.2925}
      cy={60.2565}
      rx={1.33618}
      ry={2.00427}
      transform="rotate(88.534 90.2925 60.2565)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={89.9714}
      cy={60.7524}
      rx={2.43116}
      ry={3.64673}
      transform="rotate(91.3833 89.9714 60.7524)"
      fill="white"
      fillOpacity={0.06}
    />
    <circle
      cx={108.083}
      cy={87.7953}
      r={7.10224}
      transform="rotate(84.1734 108.083 87.7953)"
      fill="url(#paint11_radial_25_671)"
    />
    <circle
      cx={108.083}
      cy={87.7953}
      r={7.10224}
      transform="rotate(84.1734 108.083 87.7953)"
      fill="url(#paint12_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={108.083}
      cy={87.7953}
      r={7.10224}
      transform="rotate(84.1734 108.083 87.7953)"
      fill="url(#paint13_radial_25_671)"
    />
    <ellipse
      cx={112.371}
      cy={85.7712}
      rx={0.789138}
      ry={1.05218}
      transform="rotate(133.217 112.371 85.7712)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={113.705}
      cy={87.3825}
      rx={0.254501}
      ry={0.339335}
      transform="rotate(161.201 113.705 87.3825)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={107.837}
      cy={82.7965}
      rx={1.05218}
      ry={1.57828}
      transform="rotate(88.534 107.837 82.7965)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={107.584}
      cy={83.187}
      rx={1.91443}
      ry={2.87165}
      transform="rotate(91.3833 107.584 83.187)"
      fill="white"
      fillOpacity={0.06}
    />
    <circle
      cx={69.2156}
      cy={87.5598}
      r={53.549}
      fill="url(#paint14_radial_25_671)"
    />
    <circle
      cx={67.4004}
      cy={82.1141}
      r={24.5055}
      fill="url(#paint15_radial_25_671)"
    />
    <circle
      cx={67.4004}
      cy={82.1141}
      r={24.5055}
      fill="url(#paint16_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={67.4004}
      cy={82.1141}
      r={24.5055}
      fill="url(#paint17_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={0.916667}
      cy={0.916667}
      r={0.916667}
      transform="matrix(-0.909574 0.415541 0.415541 0.909574 78.3058 77.6383)"
      fill="#0C102B"
    />
    <circle
      cx={0.916667}
      cy={0.916667}
      r={0.916667}
      transform="matrix(-0.909574 0.415541 0.415541 0.909574 64.6675 79.4713)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.1484 83.8594C69.1337 84.1351 69.3452 84.3706 69.621 84.3854C70.346 84.4241 71.6867 84.2266 72.8471 83.8634C73.4308 83.6807 74.0048 83.4453 74.4481 83.1537C74.8679 82.8775 75.2992 82.4646 75.3298 81.8921C75.3446 81.6163 75.133 81.3808 74.8573 81.3661C74.5815 81.3513 74.346 81.5629 74.3313 81.8387C74.3273 81.9122 74.255 82.0836 73.8984 82.3183C73.5654 82.5374 73.0903 82.7394 72.5484 82.909C71.4578 83.2504 70.2416 83.4171 69.6744 83.3868C69.3986 83.372 69.1632 83.5836 69.1484 83.8594Z"
      fill="black"
    />
    <ellipse
      cx={61.9547}
      cy={66.6848}
      rx={2.72283}
      ry={3.63044}
      transform="rotate(49.0436 61.9547 66.6848)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={67.9527}
      cy={62.6698}
      rx={0.878127}
      ry={1.17084}
      transform="rotate(77.028 67.9527 62.6698)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={50.1558}
      cy={81.2065}
      rx={3.63044}
      ry={5.44566}
      transform="rotate(4.36064 50.1558 81.2065)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={51.4075}
      cy={82.2112}
      rx={6.60552}
      ry={9.90829}
      transform="rotate(7.20987 51.4075 82.2112)"
      fill="white"
      fillOpacity={0.06}
    />
    <circle cx={27.9167} cy={125.917} r={0.916667} fill="#0C102B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.0025 128.475C37.0026 128.475 37.0024 128.476 37.0017 128.478C37.0021 128.476 37.0025 128.475 37.0025 128.475ZM36.991 128.5C36.9694 128.464 36.9098 128.391 36.7533 128.297C36.481 128.133 36.0403 128 35.5 128C34.9597 128 34.519 128.133 34.2467 128.297C34.0902 128.391 34.0306 128.464 34.009 128.5C34.0306 128.536 34.0902 128.609 34.2467 128.703C34.519 128.867 34.9597 129 35.5 129C36.0403 129 36.481 128.867 36.7533 128.703C36.9098 128.609 36.9694 128.536 36.991 128.5ZM33.9975 128.475C33.9975 128.475 33.9979 128.476 33.9983 128.478C33.9976 128.476 33.9974 128.475 33.9975 128.475ZM33.9975 128.525C33.9974 128.525 33.9976 128.524 33.9983 128.522C33.9979 128.524 33.9975 128.525 33.9975 128.525ZM37.0017 128.522C37.0024 128.524 37.0026 128.525 37.0025 128.525C37.0025 128.525 37.0021 128.524 37.0017 128.522ZM35.5 130C36.8807 130 38 129.328 38 128.5C38 127.672 36.8807 127 35.5 127C34.1193 127 33 127.672 33 128.5C33 129.328 34.1193 130 35.5 130Z"
      fill="black"
    />
    <circle cx={41.0834} cy={121.917} r={0.916667} fill="#0C102B" />
    <circle
      cx={91.2906}
      cy={124.291}
      r={11.0508}
      transform="rotate(33.0706 91.2906 124.291)"
      fill="url(#paint18_radial_25_671)"
    />
    <circle
      cx={91.2906}
      cy={124.291}
      r={11.0508}
      transform="rotate(33.0706 91.2906 124.291)"
      fill="url(#paint19_radial_25_671)"
      fillOpacity={0.2}
    />
    <circle
      cx={91.2906}
      cy={124.291}
      r={11.0508}
      transform="rotate(33.0706 91.2906 124.291)"
      fill="url(#paint20_radial_25_671)"
    />
    <ellipse
      cx={93.0294}
      cy={117.12}
      rx={1.22786}
      ry={1.63715}
      transform="rotate(82.1142 93.0294 117.12)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={96.284}
      cy={117.079}
      rx={0.395992}
      ry={0.52799}
      transform="rotate(110.099 96.284 117.079)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={84.9973}
      cy={119.704}
      rx={1.63715}
      ry={2.45572}
      transform="rotate(37.4313 84.9973 119.704)"
      fill="white"
      fillOpacity={0.17}
    />
    <ellipse
      cx={85.223}
      cy={120.392}
      rx={2.97877}
      ry={4.46815}
      transform="rotate(40.2805 85.223 120.392)"
      fill="white"
      fillOpacity={0.06}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 0C19.7909 0 18 1.79087 18 4V14.8571C18 17.0663 19.7909 18.8571 22 18.8571H82.3553L85.7228 24L89.0902 18.8571H104C106.209 18.8571 108 17.0663 108 14.8571V4C108 1.79086 106.209 0 104 0H22Z"
      fill="#2923D6"
    />
    <path
      d="M29.3515 12.096C28.9355 12.096 28.5701 11.9787 28.2555 11.744C27.9408 11.504 27.6955 11.168 27.5195 10.736C27.3435 10.304 27.2555 9.792 27.2555 9.2C27.2555 8.61867 27.3435 8.112 27.5195 7.68C27.6955 7.248 27.9461 6.912 28.2715 6.672C28.6021 6.42667 28.9968 6.304 29.4555 6.304C30.0101 6.304 30.4555 6.456 30.7915 6.76C31.1328 7.064 31.3408 7.49333 31.4155 8.048H30.4955C30.4421 7.76 30.3248 7.53067 30.1435 7.36C29.9675 7.18933 29.7381 7.104 29.4555 7.104C29.0235 7.104 28.6928 7.29067 28.4635 7.664C28.2341 8.03733 28.1195 8.54933 28.1195 9.2C28.1195 9.87733 28.2395 10.3973 28.4795 10.76C28.7248 11.1173 29.0421 11.296 29.4315 11.296C29.6928 11.296 29.9088 11.2187 30.0795 11.064C30.2501 10.9093 30.3808 10.712 30.4715 10.472C30.5621 10.2267 30.6181 9.968 30.6395 9.696H29.4635V8.992H31.4955V12H30.7115L30.6555 11.248H30.6075C30.5008 11.4933 30.3515 11.696 30.1595 11.856C29.9675 12.016 29.6981 12.096 29.3515 12.096ZM32.4363 12V11.264H33.4043V9.032C33.4043 8.856 33.319 8.768 33.1483 8.768H32.5163V8.032H33.4683C33.687 8.032 33.8657 8.096 34.0043 8.224C34.143 8.34667 34.2123 8.52 34.2123 8.744V8.84H34.2523C34.311 8.54133 34.4363 8.31733 34.6283 8.168C34.8257 8.01333 35.111 7.936 35.4843 7.936H36.1003V8.832H35.2363C34.9217 8.832 34.679 8.94133 34.5083 9.16C34.3377 9.37867 34.2523 9.64 34.2523 9.944V11.264H35.4843V12H32.4363ZM38.6572 12.096C38.3425 12.096 38.0785 12.0427 37.8652 11.936C37.6519 11.824 37.4919 11.6773 37.3852 11.496C37.2785 11.3093 37.2252 11.1067 37.2252 10.888C37.2252 10.4987 37.3665 10.1947 37.6492 9.976C37.9372 9.75733 38.3425 9.648 38.8652 9.648H39.8892V9.56C39.8892 8.96267 39.6119 8.664 39.0572 8.664C38.8279 8.664 38.6332 8.71467 38.4732 8.816C38.3185 8.912 38.2145 9.06933 38.1612 9.288H37.3132C37.3559 8.872 37.5345 8.544 37.8492 8.304C38.1692 8.05867 38.5719 7.936 39.0572 7.936C39.6439 7.936 40.0705 8.08 40.3372 8.368C40.6039 8.656 40.7372 9.05333 40.7372 9.56V12H40.0172L39.9452 11.416H39.8892C39.7719 11.6027 39.6252 11.7627 39.4492 11.896C39.2732 12.0293 39.0092 12.096 38.6572 12.096ZM38.8172 11.384C39.1639 11.384 39.4225 11.28 39.5932 11.072C39.7692 10.8587 39.8652 10.5893 39.8812 10.264H38.9532C38.6492 10.264 38.4332 10.3147 38.3052 10.416C38.1825 10.512 38.1212 10.648 38.1212 10.824C38.1212 11 38.1825 11.1387 38.3052 11.24C38.4332 11.336 38.6039 11.384 38.8172 11.384ZM41.9661 13.76V8.032H42.7021L42.7661 8.64H42.8141C42.9208 8.44267 43.0808 8.27733 43.2941 8.144C43.5128 8.00533 43.7714 7.936 44.0701 7.936C44.3794 7.936 44.6621 8.016 44.9181 8.176C45.1741 8.33067 45.3768 8.56267 45.5261 8.872C45.6808 9.176 45.7581 9.55733 45.7581 10.016C45.7581 10.4693 45.6781 10.8507 45.5181 11.16C45.3634 11.4693 45.1528 11.704 44.8861 11.864C44.6194 12.0187 44.3208 12.096 43.9901 12.096C43.6968 12.096 43.4514 12.0373 43.2541 11.92C43.0568 11.8027 42.9101 11.6693 42.8141 11.52V13.76H41.9661ZM43.8461 11.288C44.1448 11.288 44.3928 11.1813 44.5901 10.968C44.7928 10.7547 44.8941 10.4347 44.8941 10.008C44.8941 9.58133 44.7928 9.264 44.5901 9.056C44.3928 8.848 44.1448 8.744 43.8461 8.744C43.5421 8.744 43.2888 8.85067 43.0861 9.064C42.8888 9.272 42.7901 9.58933 42.7901 10.016C42.7901 10.4373 42.8888 10.7547 43.0861 10.968C43.2888 11.1813 43.5421 11.288 43.8461 11.288ZM46.795 12V6.24H47.643V8.624C47.7496 8.42667 47.9203 8.264 48.155 8.136C48.3896 8.00267 48.6536 7.936 48.947 7.936C49.4376 7.936 49.811 8.08533 50.067 8.384C50.323 8.67733 50.451 9.10133 50.451 9.656V12H49.603V9.776C49.603 9.44533 49.523 9.18933 49.363 9.008C49.203 8.82667 48.9816 8.736 48.699 8.736C48.4056 8.736 48.155 8.83467 47.947 9.032C47.7443 9.22933 47.643 9.51467 47.643 9.888V12H46.795ZM56.2607 12V6.4H57.6047C58.506 6.4 59.1754 6.65067 59.6127 7.152C60.05 7.648 60.2687 8.33067 60.2687 9.2C60.2687 10.0693 60.05 10.7547 59.6127 11.256C59.1754 11.752 58.506 12 57.6047 12H56.2607ZM57.1087 11.216H57.5727C58.2234 11.216 58.6927 11.0347 58.9807 10.672C59.2687 10.304 59.4127 9.81333 59.4127 9.2C59.4127 8.58667 59.2687 8.09867 58.9807 7.736C58.6927 7.368 58.2234 7.184 57.5727 7.184H57.1087V11.216ZM60.8256 12L62.4976 6.4H63.5056L65.1776 12H64.2576L63.8816 10.656H62.1216L61.7456 12H60.8256ZM62.9776 7.6L62.3136 9.976H63.6896L63.0256 7.6H62.9776ZM67.7825 12.096C67.4038 12.096 67.0651 12.0187 66.7665 11.864C66.4731 11.7093 66.2411 11.4747 66.0705 11.16C65.8998 10.84 65.8145 10.4373 65.8145 9.952V6.4H66.6625V10C66.6625 10.4267 66.7638 10.7573 66.9665 10.992C67.1691 11.2213 67.4465 11.336 67.7985 11.336C68.1505 11.336 68.4278 11.2213 68.6305 10.992C68.8331 10.7573 68.9345 10.4267 68.9345 10V6.4H69.7825V9.952C69.7825 10.4373 69.6945 10.84 69.5185 11.16C69.3425 11.4747 69.1025 11.7093 68.7985 11.864C68.4998 12.0187 68.1611 12.096 67.7825 12.096ZM72.6273 12.096C72.1047 12.096 71.6887 11.9733 71.3793 11.728C71.07 11.4827 70.894 11.1573 70.8513 10.752H71.7233C71.7553 10.9387 71.8487 11.0907 72.0033 11.208C72.1633 11.3253 72.374 11.384 72.6353 11.384C72.886 11.384 73.078 11.3333 73.2113 11.232C73.35 11.1253 73.4193 11.0027 73.4193 10.864C73.4193 10.6613 73.3367 10.5227 73.1713 10.448C73.0113 10.3733 72.774 10.3173 72.4593 10.28C72.1873 10.248 71.9393 10.1867 71.7153 10.096C71.4967 10 71.3233 9.872 71.1953 9.712C71.0673 9.54667 71.0033 9.34133 71.0033 9.096C71.0033 8.74933 71.1393 8.46933 71.4113 8.256C71.6833 8.04267 72.062 7.936 72.5473 7.936C73.0327 7.936 73.4087 8.04533 73.6753 8.264C73.942 8.48267 74.0967 8.78133 74.1393 9.16H73.3233C73.302 9 73.2193 8.87467 73.0753 8.784C72.9313 8.688 72.7527 8.64 72.5393 8.64C72.3207 8.64 72.1473 8.68267 72.0193 8.768C71.8913 8.848 71.8273 8.95467 71.8273 9.088C71.8273 9.376 72.1367 9.552 72.7553 9.616C73.0487 9.648 73.31 9.704 73.5393 9.784C73.7687 9.85867 73.95 9.97867 74.0833 10.144C74.2167 10.304 74.2833 10.5307 74.2833 10.824C74.2887 11.064 74.2193 11.28 74.0753 11.472C73.9367 11.664 73.742 11.816 73.4913 11.928C73.246 12.04 72.958 12.096 72.6273 12.096ZM80.3411 13.76V8.032H81.0771L81.1411 8.64H81.1891C81.2958 8.44267 81.4558 8.27733 81.6691 8.144C81.8878 8.00533 82.1464 7.936 82.4451 7.936C82.7544 7.936 83.0371 8.016 83.2931 8.176C83.5491 8.33067 83.7518 8.56267 83.9011 8.872C84.0558 9.176 84.1331 9.55733 84.1331 10.016C84.1331 10.4693 84.0531 10.8507 83.8931 11.16C83.7384 11.4693 83.5278 11.704 83.2611 11.864C82.9944 12.0187 82.6958 12.096 82.3651 12.096C82.0718 12.096 81.8264 12.0373 81.6291 11.92C81.4318 11.8027 81.2851 11.6693 81.1891 11.52V13.76H80.3411ZM82.2211 11.288C82.5198 11.288 82.7678 11.1813 82.9651 10.968C83.1678 10.7547 83.2691 10.4347 83.2691 10.008C83.2691 9.58133 83.1678 9.264 82.9651 9.056C82.7678 8.848 82.5198 8.744 82.2211 8.744C81.9171 8.744 81.6638 8.85067 81.4611 9.064C81.2638 9.272 81.1651 9.58933 81.1651 10.016C81.1651 10.4373 81.2638 10.7547 81.4611 10.968C81.6638 11.1813 81.9171 11.288 82.2211 11.288ZM85.13 12V11.264H86.458V7.24C86.458 7.064 86.3726 6.976 86.202 6.976H85.242V6.24H86.354C86.6633 6.24 86.898 6.32267 87.058 6.488C87.2233 6.648 87.306 6.88267 87.306 7.192V11.264H88.642V12H85.13ZM91.8148 12.096C91.2922 12.096 90.8762 11.9733 90.5668 11.728C90.2575 11.4827 90.0815 11.1573 90.0388 10.752H90.9108C90.9428 10.9387 91.0362 11.0907 91.1908 11.208C91.3508 11.3253 91.5615 11.384 91.8228 11.384C92.0735 11.384 92.2655 11.3333 92.3988 11.232C92.5375 11.1253 92.6068 11.0027 92.6068 10.864C92.6068 10.6613 92.5242 10.5227 92.3588 10.448C92.1988 10.3733 91.9615 10.3173 91.6468 10.28C91.3748 10.248 91.1268 10.1867 90.9028 10.096C90.6842 10 90.5108 9.872 90.3828 9.712C90.2548 9.54667 90.1908 9.34133 90.1908 9.096C90.1908 8.74933 90.3268 8.46933 90.5988 8.256C90.8708 8.04267 91.2495 7.936 91.7348 7.936C92.2202 7.936 92.5962 8.04533 92.8628 8.264C93.1295 8.48267 93.2842 8.78133 93.3268 9.16H92.5108C92.4895 9 92.4068 8.87467 92.2628 8.784C92.1188 8.688 91.9402 8.64 91.7268 8.64C91.5082 8.64 91.3348 8.68267 91.2068 8.768C91.0788 8.848 91.0148 8.95467 91.0148 9.088C91.0148 9.376 91.3242 9.552 91.9428 9.616C92.2362 9.648 92.4975 9.704 92.7268 9.784C92.9562 9.85867 93.1375 9.97867 93.2708 10.144C93.4042 10.304 93.4708 10.5307 93.4708 10.824C93.4762 11.064 93.4068 11.28 93.2628 11.472C93.1242 11.664 92.9295 11.816 92.6788 11.928C92.4335 12.04 92.1455 12.096 91.8148 12.096ZM95.8597 10.24L95.8117 9.008H96.1157C96.5637 9.008 96.9024 8.92533 97.1317 8.76C97.3664 8.58933 97.4837 8.32533 97.4837 7.968C97.4837 7.696 97.3957 7.47733 97.2197 7.312C97.049 7.14667 96.8117 7.064 96.5077 7.064C96.2197 7.064 95.9877 7.144 95.8117 7.304C95.6357 7.45867 95.5344 7.66933 95.5077 7.936H94.7077C94.7184 7.616 94.7957 7.33333 94.9397 7.088C95.0837 6.84267 95.289 6.65067 95.5557 6.512C95.8224 6.37333 96.1397 6.304 96.5077 6.304C97.0784 6.304 97.521 6.45333 97.8357 6.752C98.1504 7.04533 98.3077 7.44533 98.3077 7.952C98.3077 8.30933 98.2277 8.608 98.0677 8.848C97.9077 9.08267 97.697 9.264 97.4357 9.392C97.1797 9.51467 96.905 9.58933 96.6117 9.616L96.5877 10.24H95.8597ZM96.2037 12.048C96.0064 12.048 95.8384 11.984 95.6997 11.856C95.561 11.7227 95.4917 11.5627 95.4917 11.376C95.4917 11.1893 95.561 11.032 95.6997 10.904C95.8384 10.776 96.0064 10.712 96.2037 10.712C96.4064 10.712 96.5744 10.776 96.7077 10.904C96.8464 11.032 96.9157 11.1893 96.9157 11.376C96.9157 11.5627 96.8464 11.7227 96.7077 11.856C96.5744 11.984 96.4064 12.048 96.2037 12.048Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.9376 54.6602) rotate(-131.711) scale(20.5838)"
      >
        <stop stopColor="#2618D2" />
        <stop offset={0.355} stopColor="#3243DB" />
        <stop offset={1} stopColor="#686DEF" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.2695 53.9921) rotate(-129.611) scale(12.5745 10.8179)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.0463 50.5744) rotate(16.5648) scale(10.7116)"
      >
        <stop offset={0.754747} stopColor="white" stopOpacity={0} />
        <stop offset={1} stopColor="#5EC5FF" stopOpacity={0.57} />
      </radialGradient>
      <radialGradient
        id="paint3_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(36.2646 126.5) rotate(91.2189) scale(29.2786)"
      >
        <stop offset={0.355} stopColor="#00B3FF" />
        <stop offset={1} stopColor="#0047FF" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint4_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.9523 129.762) rotate(-131.711) scale(35.3743)"
      >
        <stop stopColor="#189AD2" />
        <stop offset={0.355} stopColor="#32BDDB" />
        <stop offset={1} stopColor="#68EFCF" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.8041 128.614) rotate(-129.611) scale(21.6099 18.5911)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.2115 123.447) rotate(90) scale(15.5)"
      >
        <stop offset={0.693364} stopColor="white" />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_25_671"
        x1={15.9824}
        y1={120.449}
        x2={41.0653}
        y2={113.49}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0} />
        <stop offset={1} stopColor="white" stopOpacity={0.27} />
      </linearGradient>
      <radialGradient
        id="paint8_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(93.9449 70.279) rotate(-131.711) scale(20.5838)"
      >
        <stop stopColor="#D2189E" />
        <stop offset={0.355} stopColor="#DB32D4" />
        <stop offset={1} stopColor="#686DEF" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(93.2768 69.6109) rotate(-129.611) scale(12.5745 10.8179)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90.0536 66.1932) rotate(16.5648) scale(10.7116)"
      >
        <stop offset={0.754747} stopColor="white" stopOpacity={0} />
        <stop offset={1} stopColor="#5EC5FF" stopOpacity={0.57} />
      </radialGradient>
      <radialGradient
        id="paint11_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(110.713 90.6888) rotate(-131.711) scale(16.2088)"
      >
        <stop stopColor="#C8FFFF" />
        <stop offset={0.355} stopColor="#32DBC7" />
        <stop offset={1} stopColor="#7177F9" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(110.187 90.1627) rotate(-129.611) scale(9.90186 8.51862)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(107.649 87.4714) rotate(16.5648) scale(8.43495)"
      >
        <stop offset={0.754747} stopColor="white" stopOpacity={0} />
        <stop offset={1} stopColor="#5EC5FF" stopOpacity={0.57} />
      </radialGradient>
      <radialGradient
        id="paint14_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.2156 87.5598) rotate(91.2189) scale(44.1644)"
      >
        <stop offset={0.355} stopColor="#0006FF" />
        <stop offset={1} stopColor="#0047FF" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint15_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(76.4765 92.0978) rotate(-131.711) scale(55.9267)"
      >
        <stop stopColor="#1E18D2" />
        <stop offset={0.355} stopColor="#3832DB" />
        <stop offset={1} stopColor="#B468EF" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(74.6613 90.2826) rotate(-129.611) scale(34.1652 29.3925)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(68 82) rotate(42.4364) scale(23.7118)"
      >
        <stop offset={0.767539} stopColor="#0019FF" stopOpacity={0} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(95.3835 128.793) rotate(-131.711) scale(25.2202)"
      >
        <stop stopColor="#184CD2" />
        <stop offset={0.355} stopColor="#3276DB" />
        <stop offset={1} stopColor="#68AEEF" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(94.5649 127.974) rotate(-129.611) scale(15.4068 13.2546)"
      >
        <stop offset={0.755} stopColor="#3631DA" stopOpacity={0.21} />
        <stop offset={1} stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_25_671"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90.6157 123.787) rotate(16.5648) scale(13.1244)"
      >
        <stop offset={0.754747} stopColor="white" stopOpacity={0} />
        <stop offset={1} stopColor="#5EC5FF" stopOpacity={0.57} />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgComponent;
